module.exports = __webpack_public_path__ + "img/nav-right-search-below-infiniti.7947f20a.png";